import { render, staticRenderFns } from "./PrincipalTable.vue?vue&type=template&id=06f73fbe"
import script from "./PrincipalTable.vue?vue&type=script&lang=js"
export * from "./PrincipalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports